import React from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaPhone, FaInstagram } from 'react-icons/fa';
import { Location } from '../data/locations';

interface LocationCardProps {
  location: Location;
}

const LocationCard: React.FC<LocationCardProps> = ({ location }) => {
  return (
    <div className="location-card">
      <div className="location-card-header">
        <h3>{location.name}</h3>
        <div className="location-badge">
          {location.bookingStatus === 'active' ? (
            <span className="badge-active">Now Open</span>
          ) : (
            <span className="badge-coming-soon">Coming Soon</span>
          )}
        </div>
      </div>

      <div className="location-details">
        <div className="location-detail">
          {React.createElement(FaMapMarkerAlt as React.ComponentType)}
          <span>{location.fullAddress}</span>
        </div>

        <div className="location-detail">
          {React.createElement(FaPhone as React.ComponentType)}
          <span>{location.phone}</span>
        </div>

        <div className="location-detail">
          {React.createElement(FaInstagram as React.ComponentType)}
          <a href={location.instagram} target="_blank" rel="noopener noreferrer">
            {location.instagramHandle}
          </a>
        </div>
      </div>

      <div className="location-card-actions">
        <Link to={`/${location.id}`} className="btn btn-primary">
          Visit {location.name}
        </Link>
        {location.bookingStatus === 'active' && location.bookingUrl && (
          <a
            href={location.bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-secondary"
          >
            Book Now
          </a>
        )}
      </div>
    </div>
  );
};

export default LocationCard; 